<template>
  <!--START FOOTER ALTER-->
  <div class="footer-alt">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="float-left pull-none ">
            <p class="copy-rights text-muted">
              2019 © JM Software - Jorge Machado
            </p>
          </div>
          <div class="float-right pull-none ">
            <img src="images/payment.png" alt="payment-img" height="36" />
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <!--START FOOTER ALTER-->
</template>

<script>
export default {
  name: "FooterAlter",
  props: {}
};
</script>
